"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var _isEmpty = _interopRequireDefault(require("lodash/fp/isEmpty"));
var _contains = _interopRequireDefault(require("lodash/fp/contains"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _curryRight = _interopRequireDefault(require("lodash/fp/curryRight"));
var _LocaleContext = require("@active/react-utils/i18n/LocaleContext");
var _Locale = _interopRequireDefault(require("@active/react-utils/i18n/Locale"));
var _useLocale2 = _interopRequireDefault(require("@active/react-utils/i18n/useLocale"));
var _Form = require("@active/react-ui/Form");
var _FormGroup = _interopRequireDefault(require("@active/react-ui/FormGroup"));
var _FormField = _interopRequireDefault(require("@active/react-ui/FormField"));
var _FormLabel = _interopRequireDefault(require("@active/react-ui/FormLabel"));
var _ResponsiveDropdown = _interopRequireDefault(require("@active/react-ui/ResponsiveDropdown"));
var _MenuItemList = _interopRequireDefault(require("@active/react-ui/MenuItemList"));
var _MenuItem = _interopRequireDefault(require("@active/react-ui/MenuItem"));
var _AddressStatic = _interopRequireDefault(require("./AddressStatic"));
var _useAddress2 = _interopRequireDefault(require("./useAddress"));
var _excluded = ["name", "label", "required", "component", "data"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FIELD_PREFIX = 'addressForm.addressField';
var SIMPLE_ADDRESS_FIELDS = ['stateProvince', 'stateProvince1', 'city', 'city1'];
var AddressEditor = function AddressEditor(props, ref) {
  var _fieldsConfig$country, _fieldsConfig$country2;
  var name = props.name,
    avs = props.avs,
    value = props.value,
    onChange = props.onChange,
    autoCorrect = props.autoCorrect,
    setFieldValue = props.setFieldValue,
    setFieldTouched = props.setFieldTouched,
    onCorrect = props.onCorrect,
    countriesConfig = props.countriesConfig,
    staticDisplay = props["static"],
    streamlined = props.streamlined,
    required = props.required,
    _props$fieldsConfig = props.fieldsConfig,
    fieldsConfig = _props$fieldsConfig === void 0 ? {} : _props$fieldsConfig,
    autoComplete = props.autoComplete,
    includeEmptyOption = props.includeEmptyOption,
    extendCorrectionRequest = props.extendCorrectionRequest;
  var _useAddress = (0, _useAddress2["default"])({
      name: name,
      avs: avs,
      value: value,
      onChange: onChange,
      autoCorrect: autoCorrect,
      onFieldValueChange: setFieldValue,
      onFieldTouch: setFieldTouched,
      onCorrect: onCorrect,
      countriesConfig: countriesConfig,
      extendCorrectionRequest: extendCorrectionRequest
    }),
    fields = _useAddress.fields,
    address = _useAddress.address,
    countries = _useAddress.countries,
    onCountryChange = _useAddress.onCountryChange,
    correct = _useAddress.correct;
  var _useLocale = (0, _useLocale2["default"])(),
    i18n = _useLocale.i18n;
  (0, _react.useImperativeHandle)(ref, function () {
    return {
      correct: correct
    };
  });
  if (staticDisplay) {
    return /*#__PURE__*/_react["default"].createElement(_AddressStatic["default"], {
      address: address
    });
  }
  return (0, _isEmpty["default"])(countries) ? null : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
    key: "country",
    name: "".concat(name, ".country"),
    label: /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
      htmlFor: (_fieldsConfig$country = fieldsConfig.country) === null || _fieldsConfig$country === void 0 ? void 0 : _fieldsConfig$country.id
    }, /*#__PURE__*/_react["default"].createElement(_Locale["default"], {
      id: "".concat(FIELD_PREFIX, ".country")
    })),
    field: /*#__PURE__*/_react["default"].createElement(_FormField["default"], (0, _extends2["default"])({
      as: _ResponsiveDropdown["default"],
      onChange: onCountryChange
    }, fieldsConfig.country, {
      placeholder: includeEmptyOption ? '' : (_fieldsConfig$country2 = fieldsConfig.country) === null || _fieldsConfig$country2 === void 0 ? void 0 : _fieldsConfig$country2.placeholder
    }), /*#__PURE__*/_react["default"].createElement(_MenuItemList["default"], null, includeEmptyOption && /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      value: ''
    }, i18n('react-ui.common.dropdown.option.empty')), countries.map(function (country) {
      return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        key: country.value,
        value: country.value
      }, country.text);
    }))),
    required: required
  }), address.country ? fields.map(function (field) {
    var _fieldsConfig$fieldNa;
    var fieldName = field.name,
      label = field.label,
      fieldRequired = field.required,
      component = field.component,
      data = field.data,
      fieldProps = (0, _objectWithoutProperties2["default"])(field, _excluded);
    return streamlined && !(0, _contains["default"])(fieldName)(SIMPLE_ADDRESS_FIELDS) ? null : /*#__PURE__*/_react["default"].createElement(_FormGroup["default"], {
      key: fieldName,
      name: "".concat(name, ".").concat(fieldName),
      label: /*#__PURE__*/_react["default"].createElement(_FormLabel["default"], {
        htmlFor: (_fieldsConfig$fieldNa = fieldsConfig[fieldName]) === null || _fieldsConfig$fieldNa === void 0 ? void 0 : _fieldsConfig$fieldNa.id
      }, label),
      field: /*#__PURE__*/_react["default"].createElement(_FormField["default"], (0, _extends2["default"])({
        as: component,
        autoComplete: data ? undefined : autoComplete
      }, fieldProps, fieldsConfig[fieldName]), data && /*#__PURE__*/_react["default"].createElement(_MenuItemList["default"], null, data.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
          key: item.value,
          value: item.value
        }, item.text);
      }))),
      required: fieldRequired
    });
  }) : null);
};
var AddressEditorConnected = (0, _compose["default"])((0, _curryRight["default"])(_Form.connectForm)(function (_ref, _ref2) {
  var _ref$form = _ref.form,
    values = _ref$form.values,
    setFieldValue = _ref$form.setFieldValue,
    setFieldTouched = _ref$form.setFieldTouched;
  var name = _ref2.name;
  return {
    value: (0, _prop["default"])(name)(values),
    setFieldValue: setFieldValue,
    setFieldTouched: setFieldTouched
  };
}), _LocaleContext.withI18n, _react.forwardRef)(AddressEditor);
var _default = exports["default"] = AddressEditorConnected;